// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/ContactInfo.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/ContactInfo.tsx");
  import.meta.hot.lastModified = "1732036222056.1943";
}
// REMIX HMR END

import ContentWrapper from "~/components/ContentWrapper";
import Link from "~/components/Link";
import IconResolver from "../IconResolver";
const items = [{
  label: "Email",
  value: "hq@octahedroid.com",
  icon: "email",
  link: "mailto:hq@octahedroid.com"
}, {
  label: "Schedule",
  value: "Free consultation",
  icon: "calendar",
  link: "https://calendly.com/jmolivas/free-one-to-one-consultation"
}, {
  label: "Call us",
  value: "760-618-1215",
  icon: "phone",
  link: "tel:760-618-1215"
}];
export default function ContactForm() {
  return <ContentWrapper spacing="primary" className="bg-neutral-100">
      <ul className="w-full flex flex-col gap-10 md:gap-0 md:flex-row md:justify-between">
        {items.map(item => <li key={item.label} className="flex flex-col">
            <p className="text-primary-700 flex items-center">
              <IconResolver token={item.icon} className="mr-2 w-4.5 h-4.5" />
              <span className="font-semibold text-xl">{item.label}</span>
            </p>
            <Link target="_blank" rel="noopener noreferrer" to={item.link}>
              {item.value}
            </Link>
          </li>)}
      </ul>
    </ContentWrapper>;
}
_c = ContactForm;
var _c;
$RefreshReg$(_c, "ContactForm");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;